<template>
    <div class="p-relative">

        <Toolbar
            :is-list="true"
            v-on:toolbar-button-click="onToolbarClick"
        >
           <!--  <SearchPanel
                v-model="search"
                :has-filter="false"
            /> -->
        </Toolbar>

        <v-form class="wrapperForm" ref="form" lazy-validation>
            <ejs-gantt 
                ref="gantt"
                :dataSource="ganttData" 
                :taskFields="taskSettings"
                :timelineSettings="timelineSettings"
                :splitterSettings="splitterSettings"
                :includeWeekend="true"
                :dayWorkingTime="[{ from: 0, to: 24 }]"
                :projectStartDate="new Date(2026, 0, 1)"
                :projectEndDate="new Date(2026, 11, 31)"
                locale="ru"
                dateFormat="dd.MM.yyyy"
                :columns="columns"
                :editSettings="editSettings"
                :recordDoubleClick="(event) => $eventBus.$emit('open-document', { id: event.rowData.TaskID, type: 'None.Indicators.Indicator' })"
                :autoCalculateDateScheduling="false"
                >
            </ejs-gantt>   
            <!--:height="'860px'"-->
        </v-form>


    </div>
</template>

<script>
import i18n from '@/i18n';
import { httpAPI } from "@/api/httpAPI";
import Toolbar from '@/components/documents/Toolbar.vue';
import { registerLicense } from "@syncfusion/ej2-base";
import { mapGetters } from 'vuex';
import { GanttPlugin, GanttComponent, Toolbar as GanttToolbar, Edit, Selection } from '@syncfusion/ej2-vue-gantt';
registerLicense("Ngo9BigBOggjGyl/Vkd+XU9FcVRDX3xKf0x/TGpQb19xflBPallYVBYiSV9jS3tSdkVhWXdbeXVST2ZUUk91Xg==");

import { L10n, setCulture } from '@syncfusion/ej2-base';
setCulture('ru');
// Загружаем словарь переводов
L10n.load({
    'ru': {
        'gantt': {
            'id': 'Индекс',
            'name': 'Название',
            'startDate': 'Дата начала',
            'endDate': 'Дата окончания',
            'duration': 'Длительность',
            'progress': 'Прогресс',
            'dependency': 'Зависимость',
            'add': 'Добавить',
            'edit': 'Изменить',
            'delete': 'Удалить',
            'update': 'Обновить',
            'cancel': 'Отмена',
            'search': 'Поиск',
            'taskLabels': 'Метки задач',
            'days': 'дн.',
            'hours': 'ч.',
            'minutes': 'мин.'
        },
        'grid': {
            'EmptyRecord': 'Записей для отображения нет',
            'True': 'Истина',
            'False': 'Ложь'
        }
    }
});

import { loadCldr } from '@syncfusion/ej2-base';

function loadCustomCulture(locale) {
  loadCldr({
    "main": {
      [locale]: {
        "dates": {
          "calendars": {
            "gregorian": {
              "months": {
                "format": {
                    "abbreviated": { "1": "Янв", "2": "Фев", "3": "Мар", "4": "Апр", "5": "Май", "6": "Июн", "7": "Июл", "8": "Авг", "9": "Сен", "10": "Окт", "11": "Ноя", "12": "Дек" },
                    "wide": { "1": "Январь", "2": "Февраль", "3": "Март", "4": "Апрель", "5": "Май", "6": "Июнь", "7": "Июль", "8": "Август", "9": "Сентябрь", "10": "Октябрь", "11": "Ноябрь", "12": "Декабрь" }
                    },
                    "stand-alone": {
                    "wide": { "1": "Январь", "2": "Февраль", "3": "Март", "4": "Апрель", "5": "Май", "6": "Июнь", "7": "Июль", "8": "Август", "9": "Сентябрь", "10": "Октябрь", "11": "Ноябрь", "12": "Декабрь" },
                    "abbreviated": { "1": "Янв", "2": "Фев", "3": "Мар", "4": "Апр", "5": "Май", "6": "Июн", "7": "Июл", "8": "Авг", "9": "Сен", "10": "Окт", "11": "Ноя", "12": "Дек" }
                    }
                },
                days: {
                        format: {
                            wide: { "sun": "воскресенье", "mon": "понедельник", "tue": "вторник", "wed": "среда", "thu": "четверг", "fri": "пятница", "sat": "суббота" },
                            abbreviated: { "sun": "вс", "mon": "пн", "tue": "вт", "wed": "ср", "thu": "чт", "fri": "пт", "sat": "сб" },
                            short: { "sun": "вс", "mon": "пн", "tue": "вт", "wed": "ср", "thu": "чт", "fri": "пт", "sat": "сб" },
                            // Добавляем narrow — это то, что он ищет для формата в одну букву
                            narrow: { "sun": "В", "mon": "П", "tue": "В", "wed": "С", "thu": "Ч", "fri": "П", "sat": "С" }
                        },
                        "stand-alone": {
                            wide: { "sun": "воскресенье", "mon": "понедельник", "tue": "вторник", "wed": "среда", "thu": "четверг", "fri": "пятница", "sat": "суббота" },
                            abbreviated: { "sun": "вс", "mon": "пн", "tue": "вт", "wed": "ср", "thu": "чт", "fri": "пт", "sat": "сб" },
                            short: { "sun": "вс", "mon": "пн", "tue": "вт", "wed": "ср", "thu": "чт", "fri": "пт", "sat": "сб" },
                            narrow: { "sun": "В", "mon": "П", "tue": "В", "wed": "С", "thu": "Ч", "fri": "П", "sat": "С" }
                        }
                },
              "dayPeriods": { "format": { "wide": { "am": "am", "pm": "pm" } } },
              "eras": { "eraAbbreviated": { "0": "BC", "1": "AD" } }
            }
          }
        },
        "numbers": {
          "defaultNumberingSystem": "latn",
          "symbols-numberSystem-latn": { "decimal": ".", "group": ",", "percentSign": "%", "plusSign": "+", "minusSign": "-" },
          "decimalFormats-numberSystem-latn": { "standard": "#,##0.###" }
        }
      }
    }
  });
}

loadCustomCulture('ru');
setCulture('ru');

// // Базовые стили (кнопки, попапы, рипплы)
// import '@syncfusion/ej2-base/styles/material.css';
// import '@syncfusion/ej2-buttons/styles/material.css';
// import '@syncfusion/ej2-popups/styles/material.css';

// // Стили таблицы (левая часть)
// import '@syncfusion/ej2-grids/styles/material.css';
// import '@syncfusion/ej2-treegrid/styles/material.css';

// // Стили самого Ганта (правая часть и общая обертка)
// import '@syncfusion/ej2-gantt/styles/material.css';
// import '@syncfusion/ej2-layouts/styles/material.css';

import Vue from 'vue';
// Регистрация плагина
Vue.use(GanttPlugin);

export default {
    name: "Indicators",
    components: {
        Toolbar,
        'ejs-gantt': GanttComponent,
    },
    provide: {
        // В provide передаем переименованный сервис Syncfusion
        gantt: [GanttToolbar, Edit, Selection]
    },
    data () {
        return {
            ganttData: [],
            // Маппинг полей (как Syncfusion должен читать твои объекты)
            taskSettings: {
                id: 'TaskID',
                name: 'TaskName',
                startDate: 'StartDate',
                endDate: 'EndDate',
                //duration: 'Duration',
                progress: 'Progress',
                child: 'subtasks', // Ключевое поле для вложенности
                dependency: 'Predecessor', // Для стрелочек связей между задачами
                manual: 'isManual'
            },
            splitterSettings: {
                position: '50%' // Устанавливает шторку ровно по центру
            },
            timelineSettings: {
                topTier: {
                    unit: 'Month',
                    format: 'MMM' // Результат: Апр., Май, Июнь...
                },
                bottomTier: {
                    unit: 'None' // Вторая строка не нужна
                },
                // Ширину можно немного уменьшить, так как текст стал короче
                timelineUnitSize: 50,
                perDayWidth: 50
            },
            editSettings: {
                allowEditing: true,
                allowAdding: false,
                allowDeleting: false,
                mode: 'Normal' 
            },
        }
    },
    computed: {
        ...mapGetters('planner', { meetingMonths: 'getMeetingMonths' }),
        locale(){
            return i18n.locale;
        },
        columns(){
            return [
                //{ field: 'TaskID', headerText: 'ID', width: 80, visible: true, isPrimaryKey: true },
                { field: 'TaskName', headerText: this.$t('Индикатор') },
                //{ field: 'Period', headerText: this.$t('Период'), width: '36%' },
                { field: 'StartDate', headerText: this.$t('Дата_начала'), format: 'dd.MM.yyyy', width: '18%' },
                { field: 'EndDate', headerText: this.$t('Дата_окончания'), format: 'dd.MM.yyyy', width: '18%' },
                //{ field: 'Duration', headerText: this.$t('Длительность'), width: 100, textAlign: 'Right' },
                { field: 'Progress', headerText: this.$t('Прогресс_%'), width: '15%', textAlign: 'Center' }
            ]
        }
    },
    
    methods: {
        async onToolbarClick(event, button) {
            if (!button.Action)
                return;

            let action = this[button.Action];

            if (action)
                action(button);
        },
        async Refresh() {
            await this.getData();
        },
        async getData(){
            const response = await httpAPI.get(`/api/plannedevent/indicatorsganttdata?filter={}`, {
                transformResponse: [function (data) {
                    return JSON.parse(data, (key, value) => {
                        if ((key === 'StartDate' || key === 'EndDate') && typeof value === 'string') {
                            const dat = new Date(value);
                            return dat;
                        }
                        return value;
                    });
                }]
            });
            if (response){
                //response.data.Payload.ganttData.forEach(element => this.doublefilds(element));
                this.ganttData = response.data.Payload.ganttData;
            }
        },
        fillPeriod(element){
            const startMonth = element.StartDate.getMonth() + 1;
            const endMonth = element.EndDate.getMonth() + 1;
            if (startMonth == endMonth)
                element.Period = `${this.$t(this.meetingMonths.find(m => m.id == startMonth)?.Value)}`;
            else 
                element.Period = `${this.$t(this.meetingMonths.find(m => m.id == startMonth)?.Value)} - ${this.$t(this.meetingMonths.find(m => m.id == endMonth)?.Value)}`;
            if (element.subtasks && Array.isArray(element.subtasks)) {
                element.subtasks.forEach(subelement => this.fillPeriod(subelement));
            }
        }
    },
    async beforeMount() {
        await this.getData();
    },
    async created() {
        let menu = [
            {
                "Action": "Refresh",
                "Icon": "refresh",
                "Items": null,
                "Text": "Обновить",
                "ToolTip": "Обновить_форму",
                "Type": null,
                Localize: true
            }
        ];
        this.$store.commit('documents/toolbar/SET_MENU', { menu });
    },
}
</script>

<style lang="css">
  /* Базовые стили */
  @import "~@syncfusion/ej2-base/styles/material.css";
  @import "~@syncfusion/ej2-buttons/styles/material.css";
  @import "~@syncfusion/ej2-popups/styles/material.css";

  /* Стили таблицы */
  @import "~@syncfusion/ej2-grids/styles/material.css";
  @import "~@syncfusion/ej2-treegrid/styles/material.css";

  /* Стили Ганта */
  @import "~@syncfusion/ej2-gantt/styles/material.css";
  @import "~@syncfusion/ej2-layouts/styles/material.css";

</style>